import * as React from "react";
import { UserBannerProps } from "../../../type";

type Props = UserBannerProps & {
  profileCompletion?: number;
};

export const UserBanner: React.FC<Props> = ({
  userId,
  userName,
  userProfile,
  membershipInfo,
  verificationStatus,
  profileCompletion = 0,
}) => {
  const pct = Math.max(0, Math.min(100, profileCompletion));
  const size = 92;
  const stroke = 6;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const dash = (pct / 100) * c;

  return (
    <div className="flex gap-5 justify-between mt-8 max-w-full bg-orange-100 rounded-xl shadow-sm w-[970px] max-md:pr-5">
      <div className="flex flex-col items-center justify-center text-center py-4 px-4 bg-amber-400 rounded-xl w-1/3 h-full">
        <div className="relative inline-flex items-center justify-center">
          <svg
            width={size}
            height={size}
            viewBox={`0 0 ${size} ${size}`}
            className="absolute -rotate-90"
            aria-label="Profile completion"
          >
            <circle
              cx={size / 2}
              cy={size / 2}
              r={r}
              stroke="rgba(255,255,255,0.6)"
              strokeWidth={stroke}
              fill="transparent"
            />
            <circle
              cx={size / 2}
              cy={size / 2}
              r={r}
              stroke="#0f766e"
              strokeWidth={stroke}
              strokeLinecap="round"
              fill="transparent"
              strokeDasharray={`${dash} ${c - dash}`}
            />
          </svg>

          <img
            loading="lazy"
            src={userProfile}
            alt="User avatar"
            className="w-20 h-20 rounded-full object-cover"
          />
          <div className="absolute -bottom-2 px-2 py-0.5 text-[11px] font-semibold bg-white rounded-full shadow">
            {pct}%
          </div>
        </div>
        <div className="mt-4 text-lg font-bold text-zinc-800">{userName}</div>
        <div className="text-sm font-medium text-zinc-800">{userId}</div>
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/5895e90ed1647bcaac27545300ff2a55635b11a8e9cf04d24663a69b0f87ea04?placeholderIfAbsent=true&apiKey=61022fe3774e4aa287a6264de6b79c87"
          alt="Decoration"
          className="object-contain mt-3 w-[68px] mx-auto"
        />
      </div>

      <div className="flex flex-col my-auto text-xs max-md:max-w-full">
        <div className="flex flex-wrap gap-5 justify-between items-start px-3.5 pt-2 pb-3.5 bg-cyan-700 rounded-md max-md:max-w-full mr-10">
          <div className="flex flex-col mt-1.5 text-white">
            <div className="self-start font-bold text-xl">{membershipInfo.title}</div>
            <div className="mt-3 font-medium">{membershipInfo.description}</div>
          </div>
        </div>

        <div className="mt-3.5 font-medium text-gray-700 max-md:max-w-full">
          <span className="text-sm font-bold leading-5">Verification in progress:</span>{" "}
          <span className="text-sm leading-5">{verificationStatus}</span>
        </div>
      </div>
    </div>
  );
};
